import { PortalBPSubMenuList } from '../list';

export class Permissions extends PortalBPSubMenuList {
  name = 'permissions';
}